import { Pipe, PipeTransform } from '@angular/core';
import { AppointmentStatus } from '@warema/shared/models';

@Pipe({
    name: 'appointmentStatusPipe',
})
export class AppointmentStatusPipe implements PipeTransform {
    public transform(appointmentStatus: AppointmentStatus): string {
        switch (appointmentStatus) {
            case AppointmentStatus.InProgress:
                return 'OPEN';

            case AppointmentStatus.Accepted:
                return 'APPROVED';

            case AppointmentStatus.Cancelled:
                return 'CANCELLED';

            case AppointmentStatus.Closed:
                return 'CLOSED';

            default:
                return 'UNKNOWN';
        }
    }
}
